import { InMemoryCacheConfig } from "@apollo/client";

import { accountQuery, tradingAccountUsersQuery } from "./account";
import { assetsQuery } from "./assets";
import { counteredOrdersQuery, offerGroupsQuery, offersQuery } from "./demo-counter-offer";
import { exportRequestsQuery } from "./demo-export-history";
import { exportRequestByIdQuery } from "./demo-export-summary";
import { retirementHistoryQuery } from "./demo-retirement-history";
import { retirementByIdQuery } from "./demo-retirement-summary";
import { documentsQuery } from "./documents";
import { generatorsQuery } from "./generators";
import { holdingsQuery } from "./holdings";
import { messagesQuery } from "./messages";
import {
  marketOrdersQuery,
  marketTradeContractQuery,
  orderHistoryQuery,
  tradeContractByIdQuery,
  tradeContractHistoryQuery,
} from "./orders";
import { plaidLinkTokenQuery } from "./plaid-link-token";
import { registriesQuery } from "./registries";
import { tenantsQuery } from "./tenants";
import { tradeContractChangeRequestHistoryQuery } from "./trade-contract-change-request-history";
import { currentTradingHaltQuery } from "./trading-halt";
import { transactionFeeQuery } from "./transaction-fee";

export const typePolicies: InMemoryCacheConfig = {
  typePolicies: {
    Query: {
      fields: {
        account: accountQuery,
        assetByAssetCode: assetsQuery,
        marketOrders: marketOrdersQuery,
        transactionFee: transactionFeeQuery,
        marketTradeContractQuery,
        currentTradingHalt: currentTradingHaltQuery,
        paginatedHoldings: holdingsQuery,
        counteredOrders: counteredOrdersQuery,
        offerGroups: offerGroupsQuery,
        offers: offersQuery,
        orderHistory: orderHistoryQuery,
        tradeContractHistory: tradeContractHistoryQuery,
        tradeContractById: tradeContractByIdQuery,
        tradeContractChangeRequestHistory: tradeContractChangeRequestHistoryQuery,
        tradingAccountUsers: tradingAccountUsersQuery,
        registries: registriesQuery,
        messages: messagesQuery,
        generators: generatorsQuery,
        documents: documentsQuery,
        tenants: tenantsQuery,
        plaidLinkToken: plaidLinkTokenQuery,
        exportRequests: exportRequestsQuery,
        exportRequestById: exportRequestByIdQuery,
        retirementHistory: retirementHistoryQuery,
        retirementById: retirementByIdQuery,
      },
    },
    Mutation: {
      fields: {
        createRecOrder: (_: any) => ({ id: "random-id" }), // return response should match the mutation response schema,
        createOffer: (_: any) => ({
          status: "PENDING",
          statusMessage: null,
          __typename: "Offer",
        }),
        createTradeContract: (_: any) => ({
          id: "random-id",
          __typename: "TradeContract",
        }),
        reviewTradeContract: (_: any) => ({
          id: "random-id",
        }),
        createTradeContractChangeRequest: (_: any) => ({
          changeRequestId: "3798e3fe-3dd8-4fd9-a4ab-8a61504efb57",
          deliveryDate: "2025-12-31",
          paymentDate: "2025-11-28",
          requestedOn: "2025-11-13T08:14:55.927Z",
          respondedOn: null,
          status: "OPEN",
          type: "OUTGOING",
          __typename: "TradeContractChangeRequest",
        }),
      },
    },
  },
};
